/**
 * Hook para detectar dispositivos mobile e tablet
 * 
 * Retorna true se a largura da tela for menor que 1024px (breakpoint lg)
 */

import { useState, useEffect } from 'react';

export function useIsMobileTablet(): boolean {
  const [isMobileTablet, setIsMobileTablet] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < 1024;
    }
    return false;
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobileTablet(window.innerWidth < 1024);
    };

    // Verificar no mount
    handleResize();

    // Adicionar listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobileTablet;
}
